/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { Classes } from "@blueprintjs/core";
var NS = Classes.getClassNamespace();
export var DATEINPUT = NS + "-dateinput";
export var DATEINPUT_POPOVER = DATEINPUT + "-popover";
export var DATEPICKER = NS + "-datepicker";
export var DATEPICKER_CAPTION = DATEPICKER + "-caption";
export var DATEPICKER_CAPTION_CARET = DATEPICKER_CAPTION + "-caret";
export var DATEPICKER_CAPTION_MEASURE = DATEPICKER_CAPTION + "-measure";
export var DATEPICKER_CAPTION_SELECT = DATEPICKER_CAPTION + "-select";
export var DATEPICKER_DAY = "DayPicker-Day";
export var DATEPICKER_DAY_DISABLED = DATEPICKER_DAY + "--disabled";
export var DATEPICKER_DAY_OUTSIDE = DATEPICKER_DAY + "--outside";
export var DATEPICKER_DAY_SELECTED = DATEPICKER_DAY + "--selected";
export var DATEPICKER_DAY_IS_TODAY = DATEPICKER_DAY + "--isToday";
export var DATEPICKER_DAY_WRAPPER = DATEPICKER + "-day-wrapper";
export var DATEPICKER_FOOTER = DATEPICKER + "-footer";
export var DATEPICKER_MONTH_SELECT = DATEPICKER + "-month-select";
export var DATEPICKER_YEAR_SELECT = DATEPICKER + "-year-select";
export var DATEPICKER_NAVBAR = DATEPICKER + "-navbar";
export var DATEPICKER_NAVBUTTON = "DayPicker-NavButton";
export var DATEPICKER_TIMEPICKER_WRAPPER = DATEPICKER + "-timepicker-wrapper";
export var DATERANGEPICKER = NS + "-daterangepicker";
export var DATERANGEPICKER_CONTIGUOUS = DATERANGEPICKER + "-contiguous";
export var DATERANGEPICKER_SINGLE_MONTH = DATERANGEPICKER + "-single-month";
export var DATERANGEPICKER_DAY_SELECTED_RANGE = DATEPICKER_DAY + "--selected-range";
export var DATERANGEPICKER_DAY_HOVERED_RANGE = DATEPICKER_DAY + "--hovered-range";
export var DATERANGEPICKER_SHORTCUTS = DATERANGEPICKER + "-shortcuts";
export var DATERANGEPICKER_TIMEPICKERS = DATERANGEPICKER + "-timepickers";
export var DATETIMEPICKER = NS + "-datetimepicker";
export var TIMEPICKER = NS + "-timepicker";
export var TIMEPICKER_ARROW_BUTTON = TIMEPICKER + "-arrow-button";
export var TIMEPICKER_ARROW_ROW = TIMEPICKER + "-arrow-row";
export var TIMEPICKER_DIVIDER_TEXT = TIMEPICKER + "-divider-text";
export var TIMEPICKER_HOUR = TIMEPICKER + "-hour";
export var TIMEPICKER_INPUT = TIMEPICKER + "-input";
export var TIMEPICKER_INPUT_ROW = TIMEPICKER + "-input-row";
export var TIMEPICKER_MILLISECOND = TIMEPICKER + "-millisecond";
export var TIMEPICKER_MINUTE = TIMEPICKER + "-minute";
export var TIMEPICKER_SECOND = TIMEPICKER + "-second";
export var TIMEPICKER_AMPM_SELECT = TIMEPICKER + "-ampm-select";
//# sourceMappingURL=classes.js.map